<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="d-sm-none d-flex justify-content-between">
    <label class="col-form-label" for="internet{{index}}">
      <span>{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.INTERNET' | translate }}</span>
    </label>
    <common-ui-daten-uebernahme (picked)="form.get('internet').setValue($event)"
                                [itemTemplate]="datenuebernahmeInternetadresse"
                                [items]="stammdatenInternetadressen" [readonly]="readonly"
                                context="Internetadresse{{index}}Xs"></common-ui-daten-uebernahme>
  </div>
  <div class="form-row">
    <label class="d-none d-sm-inline col-sm-3 col-form-label" for="internet{{index}}">
      <span class="d-flex justify-content-between">
        <span>{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.INTERNET' | translate }}</span>
      </span>
    </label>
    <div class="d-none d-sm-flex col-sm-1 common-ui-small-stammdaten-button">
      <common-ui-daten-uebernahme (picked)="form.reset($event)"
                                  [itemTemplate]="datenuebernahmeInternetadresse"
                                  [items]="stammdatenInternetadressen" [readonly]="readonly"
                                  context="Internetadresse{{index}}"
                                  imageOnly="true"></common-ui-daten-uebernahme>
    </div>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="internet{{objectId}}" formControlName="internet" id="internet{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>
  </div>
</form>

<ng-template #datenuebernahmeInternetadresse let-item="item">
  <h4 class="list-group-item-heading">{{item.internet}}</h4>
  <p *ngIf="item.notiz" class="list-group-item-text">{{item.notiz}}</p>
</ng-template>
